
<!--
1 red-pending
2 yellow-processing
3 default-packing
4 primary-onDerivery
5 completed-green
6 canceled-purple
-->
<template>
    <span v-if="statusID == 1" class="status-badge red-color"> {{ statusName }}</span>
    <span v-if="statusID == 2" class="status-badge yellow-color"> {{ statusName }}</span>
    <span v-if="statusID == 3" class="status-badge purple-color"> {{ statusName }}</span>
    <span v-if="statusID == 4" class="status-badge primary-color"> {{ statusName }}</span>
    <span v-if="statusID == 5" class="status-badge green-color"> {{ statusName }}</span>
    <span v-if="statusID == 6" class="status-badge default-color"> {{ statusName }}</span>
</template>

<script setup>

const props = defineProps({
  statusName: {
    type: String,
    required: true,
  },
  statusID: {
    type: Number,
    default: 1,
  },
});


</script>
